export default __webpack_public_path__ + "static/media/deleteTemplate.8058a76f.svg";